/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState, useEffect } from 'react'
import ActionsMenu from '../../../shared/ActionsMenu'
import { useServiceContext } from '../../../../root'
import { useNavigate } from 'react-router'

interface TableMenuProps {
  item: {
    id: string
    workflow?: Array<{
      id?: string
      formattedId?: string
    }>
  }
  options?: any
}

const TableMenu: React.FC<TableMenuProps> = ({ item, options }) => {
  const context = useServiceContext()
  const navigate = useNavigate()
  const [items, setItems] = useState([
    {
      value: 'LOADING...',
      action: () => {},
      disabled: true
    }
  ])

  useEffect(() => {
    const menuItems = []
    menuItems.push({
      value: 'Remediate Periodic Review',
      action: () => {
        navigate(`/show-file/${item.id}?action=periodicReview`)
      },
      disabled: !(
        (item?.workflow?.[0]?.id === undefined || item?.workflow?.[0]?.id === null) &&
        (item?.workflow?.[0]?.formattedId === undefined || item?.workflow?.[0]?.formattedId === null)
      )
    })
    setItems(menuItems)
  }, [item, navigate])

  return <ActionsMenu menuId={`action-menu-browser-${item.id}`} items={items} />
}

export default TableMenu
